import Container from './container';

/**
 * poppet.ActiveContainer
 * A FormEnabled Container with no initial validation.
 * @version 0.8.2
 */

const ActiveContainer = Container.extend({

	// ------------------------------------------------
	// Setup
	// ------------------------------------------------

	noInitValidation: true,

	behaviors: {
		ViewAnimator: {},
		FormEnabler: {},
	},


	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------


	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------

});

export default ActiveContainer;